export const MAX_SEARCH_LENGTH = 150;
